import snakecaseKeys from 'snakecase-keys';
import { ApiService } from '../../../ApiService';
import { SurveyRequest } from '../../../../entities/v1/reference_check/SurveyRequest';

export interface ShowParams {
  id?: number;
  applicationExternalId?: number;
}

export class SurveyRequestService {
  public static show(params: ShowParams): Promise<SurveyRequest> {
    return ApiService.get<SurveyRequest>(
      '/api/v1/reference_check/survey_requests/survey_request',
      snakecaseKeys(params),
    );
  }
}
